import { Link } from 'react-router-dom';

// Componentes
import FriendlyPhrase from '../../components/FriendlyPhrase/FriendlyPhrase';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';

// Contextos
import { useAuth } from '../../contexts/AuthContext';

// Constantes
import menuData from '../../constants/menuData';

// Estilos
import styles from './homepage.module.css';

function HomePage() {
    const { usuario } = useAuth();

    return (
        <div className={styles.HomePage}>

            <div className={styles.containerTitle}>
                <Breadcrumbs />
                <h1 className={styles.title}>Olá, {usuario.nome}.</h1>
                <FriendlyPhrase page={"home"} />
            </div>

            {menuData.map((grupo, index) => (
                <div key={index} style={{ width: '100%', maxWidth: '60rem', marginBottom: '2rem' }}>
                    <h2 className={styles.sectionTitle}>
                        {grupo.categoria} ({grupo.botoes.length})
                    </h2>

                    <div className={styles.containerBtns}>
                        {grupo.botoes.map((btn, i) => (
                            <button key={i} className={styles.btn}>
                                <Link to={btn.link} className={styles.btnText}>
                                    <btn.icone className={styles.icon} />
                                    {btn.nome}
                                </Link>
                            </button>
                        ))}
                    </div>
                </div>
            ))}

        </div>
    );
}

export default HomePage;